import React from 'react';
import ProMaxLoader from './ProMaxLoader';
import '../ProMaxLoader.css';

const BillSaveLoader = ({ 
  isVisible = false, 
  title = "Saving Bill", 
  subtitle = "Please wait while we process your transaction...",
  progress = false 
}) => {
  if (!isVisible) return null;

  return (
    <div className="bill-save-overlay">
      <div className="bill-save-content">
        <div className="bill-save-title">
          💾
          {title}
        </div>
        <div className="bill-save-subtitle">
          {subtitle}
        </div>
        <div className="bill-save-loader">
          <ProMaxLoader 
            size={32} 
            color="#56ab2f" 
            text="Processing..." 
            showText={true}
            variant="advanced"
          />
        </div>
        {progress && (
          <div className="bill-save-progress">
            <div className="bill-save-progress-bar"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BillSaveLoader;